import { render } from "./painelFiltrarTurma2.vue?vue&type=template&id=7435159b"
import script from "./painelFiltrarTurma2.vue?vue&type=script&lang=js"
export * from "./painelFiltrarTurma2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__